import { render, staticRenderFns } from "./investors-panel-accordion.vue?vue&type=template&id=68b5caa4&scoped=true&"
import script from "./investors-panel-accordion.vue?vue&type=script&lang=ts&"
export * from "./investors-panel-accordion.vue?vue&type=script&lang=ts&"
import style0 from "./investors-panel-accordion.vue?vue&type=style&index=0&id=68b5caa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b5caa4",
  null
  
)

export default component.exports